<div #consolesMenuRef class="cmx-consoles">
  <div
    (click)="toggleConsolesMenu()"
    class="cmx-consoles__nav"
    [ngClass]="{
      'cmx-consoles__nav--selected ': console?.active,
      'cmx-consoles__nav--open ': isConsolesMenuOpen
    }"
  >
    <div class="cmx-consoles__nav-title">
      {{ console?.title }}
    </div>
    <div
      *ngIf="console?.subItems && console?.subItems?.length !== 0"
      class="cmx-consoles__nav-icon cmx-icon-arrow-down-single"
      [ngClass]="{
        'cmx-consoles__nav-icon--rtl ': direction === 'rtl',
        'cmx-consoles__nav-icon--open ': isConsolesMenuOpen
      }"
    ></div>
  </div>
  <div
    *ngIf="console?.subItems && console?.subItems?.length !== 0"
    class="cmx-consoles__container popout popout--with-border"
    [ngClass]="{
      'cmx-consoles__container--closed': !isConsolesMenuOpen,
      'cmx-consoles__container--rtl': direction === 'rtl'
    }"
  >
    <div *ngFor="let subItem of console?.subItems" (click)="onItemClick(subItem.id)" class="cmx-consoles__item">
      {{ subItem?.title }}
    </div>
  </div>
</div>
